export const getOfflineMigration = (state) => state.offlineMigration;
export const wasOfflineMigrationTriggered = (state) =>
  getOfflineMigration(state).wasOfflineMigrationTriggered;
